import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  addWeeklyDepletionValuesToGrid,
  apiUrls,
  catchElement,
  elementToBase64,
  getAllCustomerTrustLevels,
  getAllCustomerTypes,
  getAllSKUList,
  getQuotaTableData,
  prepareCustomers,
  prepareGridData,
  prepareList1,
  prepareList2,
  validateCustomers,
} from "./defineUtils";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import _ from "lodash";

export const GetUserCountries = createAsyncThunk(
  "define/GetUserCountries",
  async (obj, { dispatch, getState }) => {
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    reqOptions.method = obj.method;
    let url = apiUrls.countryListUrl + data.userID;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const GetScenarioforQuotaDefinition = createAsyncThunk(
  "define/GetScenarioforQuotaDefinition",
  async (obj, { dispatch, getState }) => {
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    let headers = new Headers();
    // headers.set("Access-Control-Allow-Origin", "*");
    // headers.append("Content-Type", "application/json");
    // headers.append("Accept", "application/json");
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }
    reqOptions.headers = headers;
    reqOptions.method = obj.method;
    let url = apiUrls.GetScenarioforQuotaDefinition + obj.countryId;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const GetQuotaPeriods = createAsyncThunk(
  "define/GetQuotaPeriods",
  async (obj, { dispatch, getState }) => {
    const { selectedScenario } = getState().define;
    //console.log("currentScenario", selectedScenario);
    if (!selectedScenario.scenarioID) return null;
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    let headers = new Headers();
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }
    reqOptions.headers = headers;
    reqOptions.method = obj.method;
    let url = apiUrls.GetQuotaPeriods + selectedScenario.scenarioID;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);
export const GetQuotaPeriodsfromNavigation = createAsyncThunk(
  "define/GetQuotaPeriodsfromNavigation",
  async (obj, { dispatch, getState }) => {
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    let headers = new Headers();
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }
    reqOptions.headers = headers;
    reqOptions.method = obj.method;
    let url = apiUrls.GetQuotaPeriods + obj.scenarioID;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const GetQuotaDetails = createAsyncThunk(
  "define/GetQuotaDetails",
  async (obj, { dispatch, getState }) => {
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    let headers = new Headers();
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }
    reqOptions.headers = headers;
    reqOptions.method = obj.method;
    let url = apiUrls.GetQuotaDetails + obj.queryParams;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const GetWeeklyDepletion = createAsyncThunk(
  "define/GetWeeklyDepletion",
  async (obj, { dispatch, getState }) => {
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    let headers = new Headers();
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }
    reqOptions.headers = headers;
    reqOptions.method = obj.method;
    let url = apiUrls.GetWeeklyDepletion;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const GetWeeklyDepletionValues = createAsyncThunk(
  "define/GetWeeklyDepletionValues",
  async (obj, { dispatch, getState }) => {
    const { selectedScenario, selectedDepletion, selectedPeriod } =
      getState().define;
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    let headers = new Headers();
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }
    reqOptions.headers = headers;
    reqOptions.method = obj.method;
    let url =
      apiUrls.GetWeeklyDepletionValues +
      "?scenarioId=" +
      selectedScenario.scenarioID +
      "&WeeklyDepletion=" +
      selectedDepletion.key +
      "&startDate=" +
      selectedPeriod.startDate;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const GetSKUOrPGByScenario = createAsyncThunk(
  "define/GetSKUOrPGByScenario",
  async (obj, { dispatch, getState }) => {
    const { selectedScenario } = getState().define;
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    let headers = new Headers();
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }
    reqOptions.headers = headers;
    reqOptions.method = obj.method;
    let url = apiUrls.GetSKUOrPGByScenario + selectedScenario.scenarioID;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const GetQuotaChartData = createAsyncThunk(
  "define/GetQuotaChartData",
  async (obj, { dispatch, getState }) => {
    dispatch(setLoadData());
    const { chartObj } = getState().define;
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    let headers = new Headers();
    headers.set("Access-Control-Allow-Origin", "*");
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }
    reqOptions.headers = headers;
    reqOptions.method = obj.method;
    reqOptions.body = JSON.stringify(chartObj);
    let url = apiUrls.GetQuotaChartData;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const ExportExcel = createAsyncThunk(
  "define/ExportExcel",
  async (obj, { dispatch, getState }) => {
    const {
      selectedCountry,
      selectedScenario,
      selectedPeriod,
      selectedQuota,
      selectedDepletion,
      isWeek4Only,
    } = getState().define;
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    let headers = new Headers();
    headers.set("Access-Control-Allow-Origin", "*");
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }
    // debugger;
    reqOptions.headers = headers;
    reqOptions.method = obj.method;
    const body = {
      countryId: selectedScenario.countryID,
      countryName: selectedCountry.countryName,
      displayDate: selectedPeriod.displayDate,
      effectiveEndDate: selectedQuota.effectiveEndDate,
      effectiveStartDate: selectedQuota.effectiveStartDate,
      scenarioID: selectedScenario.scenarioID,
      scenarioName: selectedScenario.scenarioName,
      weeklyDepletion: selectedDepletion.key,
      isWeek4Only: isWeek4Only,
      listQuotaCustomers3: selectedQuota.listQuotaCustomers.map(
        ({
          customerGroupID,
          customerNumber,
          SoldToNumber,
          name,
          initialQuota,
          safetyMargin,
          unusedQuota,
          adjustment,
          quota,
          customerQuotaComments,
          skuNumb,
          packName,
          weekly1,
          weekly2,
          weekly3,
          weekly4,
          weekly5,
          customerSharePercentage,
          skuPercentage,
        }) => ({
          customerGroupID,
          customerNumber,
          SoldToNumber,
          name,
          initialQuota,
          safetyMargin,
          unusedQuota,
          adjustment,
          quota,
          customerQuotaComments,
          skuNumb,
          packName,
          weekly1,
          weekly2,
          weekly3,
          weekly4,
          weekly5,
          customerShare: customerSharePercentage,
          skuMarketShare: skuPercentage,
        })
      ),
    };
    reqOptions.body = JSON.stringify(body);
    let url = apiUrls.ExportExcel;
    return fetch(url, reqOptions).then((r) => {
      return r.blob();
    });
  }
);

export const ImportExcel = createAsyncThunk(
  "define/ImportExcel",
  async (obj, { dispatch, getState }) => {
    const { selectedCountry, selectedScenario, selectedDepletion } =
      getState().define;
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    let headers = new Headers();
    headers.set("Access-Control-Allow-Origin", "*");
    // headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Content-Disposition", "multipart/form-data");
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }

    obj.body.append("country", selectedCountry.countryName);
    obj.body.append("scenario", selectedScenario.scenarioName);
    obj.body.append("weeklyDepletion", selectedDepletion.key);

    reqOptions.headers = headers;
    reqOptions.method = obj.method;
    reqOptions.body = obj.body;
    let url = apiUrls.ImportExcel;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const SaveQuota = createAsyncThunk(
  "define/SaveQuota",
  async (obj, { dispatch, getState }) => {
    const { saveOrSubmitError } = getState().define;

    if (saveOrSubmitError === 0) {
      const { selectedQuota } = getState().define;
      let reqOptions = {};
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      let headers = new Headers();
      headers.set("Access-Control-Allow-Origin", "*");
      headers.append("Content-Type", "application/json");
      headers.append("Accept", "application/json");
      if (token) {
        headers.append("Authorization", `Bearer ${token}`);
      }
      reqOptions.headers = headers;
      reqOptions.method = obj.method;
      reqOptions.body = JSON.stringify(selectedQuota);
      let url = apiUrls.SaveQuota;
      return fetch(url, reqOptions).then((r) => {
        return r.json();
      });
    }
    return "error";
  }
);

export const Upload = createAsyncThunk(
  "define/Upload",
  async (obj, { dispatch, getState }) => {
    const { files } = getState().define;
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      formData.append("files", files[i], files[i].name);
    }
    const url = apiUrls.Upload;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Disposition": "multipart/form-data",
        },
        body: formData,
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);
export const SubmitQuota = createAsyncThunk(
  "define/SubmitQuota",
  async (obj, { dispatch, getState }) => {
    const { saveOrSubmitError } = getState().define;

    if (saveOrSubmitError === 0) {
      const { selectedQuota } = getState().define;
      let reqOptions = {};
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      let headers = new Headers();

      headers.set("Access-Control-Allow-Origin", "*");
      headers.append("Content-Type", "application/json");
      headers.append("Accept", "application/json");
      if (token) {
        headers.append("Authorization", `Bearer ${token}`);
      }
      reqOptions.headers = headers;
      reqOptions.method = obj.method;
      reqOptions.body = JSON.stringify(selectedQuota);
      console.log("Define_SubmitQuota_Payload", selectedQuota);
      let url = apiUrls.SubmitQuota;
      return fetch(url, reqOptions).then((r) => {
        return r.json();
      });
    }
    return "error";
  }
);

export const exportFile = createAsyncThunk(
  "define/exportFile",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { isPdf, payload, displayType } = obj;
    const url =
      apiUrls.exportFile + `isPdf=${isPdf}&displayType=${displayType}`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });
      const res = await response.blob();
      const extension = isPdf ? "pdf" : "xlsx";
      const fileName = `DefineFile.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const DownloadFile = createAsyncThunk(
  "define/downloadfile",
  async (filepath, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = apiUrls.Downloadfile + `fileName=${filepath}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const res = await response.blob();
      const fileName = filepath;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);
const initialState = {
  isLoading: false,
  isSuccess: false,
  isSuccess_Info: false,
  isFailed: false,
  isFailed_Info: "",
  isError: false,
  isError_Info: "",
  countries: [],
  selectedCountry: {},
  DGlobalCountryID: "",
  scenarioList: [],
  selectedScenario: {},
  quotaPeriods: [],
  selectedPeriod: {},
  weeklyDepletionList: [],
  selectedDepletion: {},
  selectedQuota: {},
  TotalAdjustment: 0,
  TotalSafetyMargin: 0,
  TotalUnusedQuota: 0,
  TotalQuota: 0,
  TotalForecast: 0,
  loadQuotaDetails: false,
  custBreakdownTableList: [],
  loadQuotaChart: false,
  chartObj: {},
  quotaChartColumns: [],
  quotaChartData: [],
  quotaChartColors: [],
  quotaChartSeriesData: [],
  quotaChartLabelNames: [],
  hideWeekColumns: true,
  listProduct: [],
  selectedProduct: {},
  selectedCustomers: [],
  multiplier: 0,
  rounder: 0,
  commonSafetyMargin: 0,
  bufferAdjustment: 0,

  gridData: [],
  gridDataFiltered: [],
  gridDataChanged: false,
  exportDataModalOpen: false,
  exportPdf: false,
  filter_customerTypes: [],
  filter_customerTrustLevels: [],
  filter_skuName: [],
  filter_skuNumber: [],
  SKUList: [],
  skuNumberList: [],
  skuNameList: [],
  onSubmitDisabled: false,
  initialForecast: 0,
  revisedQuota: 0,
  quotaCopy: 0,
  forecastType: "",
  weeklyDepletionValues: {},
  onAllocateClick: false,
  isValueChanged: false,
  files: [],

  selectedRows: [],

  customerTypes: [],
  customerTrustLevels: [],

  searchText: "",
  selectedView: 1,

  saveOrSubmitError: 0,
  files: [],
  filepath: [],
  comments: "",
  isNavigate: false,
  navigatedCountryId: 0,
  navigatedScenarioId: 0,

  showChart: true,
  quotaTableData: null,
  isWeek4Only: false,
  showMiddleColumn: false,
};

export const RoundTo = (number, roundto) => {
  if (roundto === 0) {
    return Math.round(number);
  }
  return roundto * Math.round(number / roundto);
};

export const defineSlice = createSlice({
  name: "define",
  initialState,
  reducers: {
    setState: {
      prepare(name, value) {
        return {
          payload: { name, value },
        };
      },
      reducer(state, action) {
        const { name, value } = action.payload;
        state[name] = value;
      },
    },
    setSelectedCountry(state, { payload }) {
      // debugger;
      const country = state.countries.find(
        (v) => v.countryID === parseInt(payload)
      );
      if (country) {
        state.selectedCountry = country;
      } else {
        // Fallback: if not found, set empty object
        state.selectedCountry = {};
      }
    },
    setSelectedScenario(state, { payload }) {
      state.selectedScenario = state.scenarioList.filter(
        (v) => v.scenarioID === parseInt(payload)
      )[0];
      state.hideWeekColumns =
        state.selectedScenario.periodType === "Monthly" ? true : false;
    },
    setSelectedPeriod(state, { payload }) {
      state.selectedPeriod = state.quotaPeriods.filter(
        (v) => v.displayDate === payload
      )[0];
    },
    setForecast(state, { payload }) {
      state.initialForecast = payload === "" ? 0 : parseInt(payload);
    },
    setQuotaCopy(state, { payload }) {
      state.selectedQuota.quotaCopy = payload === "" ? 0 : parseInt(payload);
    },
    setTimeDepletion(state, { payload }) {
      state.selectedDepletion = state.weeklyDepletionList.filter(
        (v) => v.value === payload
      )[0];
    },
    setSelectProduct(state, { payload }) {
      state.selectedProduct = state.listProduct.filter(
        (v) => v.packGroupOrSKUID === parseInt(payload)
      )[0];
    },
    setRounder(state, { payload }) {
      state.rounder = payload === "" ? 0 : parseInt(payload);
    },
    setSafetyMargin(state, { payload }) {
      state.commonSafetyMargin =
        payload === ""
          ? 0
          : payload === "-"
          ? "-"
          : payload === "0-"
          ? "-"
          : payload === "-0"
          ? "0"
          : parseInt(payload);
    },
    setBufferAdjustment(state, { payload }) {
      state.bufferAdjustment =
        payload === ""
          ? 0
          : payload === "-"
          ? "-"
          : payload === "0-"
          ? "-"
          : payload === "-0"
          ? "0"
          : parseInt(payload);
    },
    setApplySafetyMargin(state) {
      //state.rounder = parseInt(payload);
      //state.commonSafetyMargin =
      //   state.commonSafetyMargin === null ? 0 : state.commonSafetyMargin;

      const gridDataFiltered = _.cloneDeep(state.gridDataFiltered);
      const weeklyDepletionValues = _.cloneDeep(state.weeklyDepletionValues);
      const { week1, week2, week3, week4, week5 } = weeklyDepletionValues;
      // if (
      //    state.commonSafetyMargin !== "" && state.commonSafetyMargin !== null
      // ) {
      //    for (let i = 0; i < gridDataFiltered.length; i++) {
      //       gridDataFiltered[i].safetyMargin = state.commonSafetyMargin;
      //    }
      // }

      if (
        state.commonSafetyMargin !== "" &&
        state.commonSafetyMargin !== null &&
        !isNaN(state.commonSafetyMargin)
      ) {
        for (let i = 0; i < gridDataFiltered.length; i++) {
          let item = gridDataFiltered[i];
          let safetyMargin =
            (item.initialQuota * state.commonSafetyMargin) / 100;
          // if (
          //    state.bufferAdjustment !== "" && state.bufferAdjustment !== null
          // ){
          //    let customerName = item.name?.toLowerCase();
          //    if (item.isBuffer === true || customerName?.includes("buffer")) {
          //       item.adjustment = state.bufferAdjustment;
          //    }
          // }
          let quota = Math.round(
            item.initialQuota + safetyMargin + item.adjustment
          );
          if (quota < 0) {
            state.isError = true;
            state.isError_Info =
              "Quota submitted for each Customer/Customer Group cannot be less than Zero";
            continue;
          } else {
            item.quota = quota;
            item.safetyMargin = state.commonSafetyMargin;

            if (state.selectedDepletion.key === "None") {
              item.weekly1 = item.quota;
              item.revisedQuota = item.quota;
            } else if (state.selectedDepletion.key === "biweekly") {
              item.weekly1 = Math.round(
                item.quota * (week1 === undefined ? 0 : week1)
              );
              item.weekly2 = item.quota;
              item.weekly3 = 0;
              item.weekly4 = 0;
              item.weekly5 = 0;
              item.revisedQuota = item.weekly2;
            } else if (state.selectedDepletion.key === "depletion_80_20") {
              let w1 = week1 === undefined ? 0 : week1;
              let w2 = week2 === undefined ? 0 : week2;
              let w3 = week3 === undefined ? 0 : week3;
              let w4 = week4 === undefined ? 0 : week4;
              let w5 = week5 === undefined ? 0 : week5;

              item.weekly1 = Math.round(item.quota * w1);
              if (item.weekly1 > item.quota) {
                item.weekly1 = item.quota;
              }

              item.weekly2 = Math.round(item.quota * w2);
              if (item.weekly2 > item.quota) {
                item.weekly2 = item.quota;
              }

              item.weekly3 = Math.round(item.quota * w3);
              if (item.weekly3 > item.quota) {
                item.weekly3 = item.quota;
              }

              item.weekly4 = Math.round(item.quota * w4);
              if (item.weekly4 > item.quota) {
                item.weekly4 = item.quota;
              }
              if (item.quota * w5 !== 0) {
                item.weekly5 = item.quota;
              } else {
                item.weekly4 = item.quota;
                item.weekly5 = item.quota;
              }
              item.revisedQuota = item.quota;
            } else {
              let w1 = week1 === undefined ? 0 : week1;
              let w2 = week2 === undefined ? 0 : week2;
              let w3 = week3 === undefined ? 0 : week3;
              let w4 = week4 === undefined ? 0 : week4;
              let w5 = week5 === undefined ? 0 : week5;

              item.weekly1 = Math.round(item.quota * w1);
              if (item.weekly1 > item.quota) {
                item.weekly1 = item.quota;
              }

              item.weekly2 = Math.round(item.weekly1 + item.quota * w2);
              if (item.weekly2 > item.quota) {
                item.weekly2 = item.quota;
              }

              item.weekly3 = Math.round(item.weekly2 + item.quota * w3);
              if (item.weekly3 > item.quota) {
                item.weekly3 = item.quota;
              }

              item.weekly4 = Math.round(item.weekly3 + item.quota * w4);
              if (item.weekly4 > item.quota) {
                item.weekly4 = item.quota;
              }
              if (item.quota * w5 !== 0) {
                item.weekly5 = item.quota;
              } else {
                item.weekly4 = item.quota;
                item.weekly5 = item.quota;
              }
              item.revisedQuota = item.quota;
            }
          }
        }

        //const updatedGrid = [];
        // for (let i = 0; i < state.gridData.length; ++i) {
        //    let itemchanged = gridDataFiltered.find(
        //       (obj) =>
        //          obj.customerID === state.gridData[i].customerID &&
        //          obj.customerGroupID ===
        //             state.gridData[i].customerGroupID &&
        //          obj.productGroupID === state.gridData[i].productGroupID &&
        //          obj.skuid === state.gridData[i].skuid
        //    );
        //    if (itemchanged) {
        //       updatedGrid.push(itemchanged);
        //    } else {
        //       updatedGrid.push(state.gridData[i]);
        //    }
        // }
        const uniqueKeys = new Map();
        for (const item of gridDataFiltered) {
          const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
          uniqueKeys.set(key, item);
        }

        const updatedGrid = [];

        for (const item of state.gridData) {
          const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
          if (uniqueKeys.has(key)) {
            updatedGrid.push(uniqueKeys.get(key));
          } else {
            updatedGrid.push(item);
          }
        }
        state.gridData = updatedGrid;
        state.gridDataFiltered = gridDataFiltered;
      }
    },
    setApplyBufferAdjustment(state, { payload }) {
      const gridDataFiltered = _.cloneDeep(state.gridDataFiltered);
      const weeklyDepletionValues = _.cloneDeep(state.weeklyDepletionValues);
      const { week1, week2, week3, week4, week5 } = weeklyDepletionValues;
      if (
        state.bufferAdjustment !== "" &&
        state.bufferAdjustment !== null &&
        !isNaN(state.bufferAdjustment)
      ) {
        for (let i = 0; i < gridDataFiltered.length; i++) {
          let item = gridDataFiltered[i];
          let safetyMargin = (item.initialQuota * item.safetyMargin) / 100;
          let customerName = item.name?.toLowerCase();
          if (item.isBuffer === true || customerName?.includes("buffer")) {
            let quota = Math.round(
              item.initialQuota + safetyMargin + state.bufferAdjustment
            );
            if (quota < 0) {
              state.isError = true;
              state.isError_Info =
                "Quota submitted for each Customer/Customer Group cannot be less than Zero";
              continue;
            } else {
              item.adjustment = state.bufferAdjustment;
              item.quota = quota;
            }
          } else {
            continue;
          }

          if (state.selectedDepletion.key === "None") {
            item.weekly1 = item.quota;
            item.revisedQuota = item.quota;
          } else if (state.selectedDepletion.key === "biweekly") {
            item.weekly1 = Math.round(
              item.quota * (week1 === undefined ? 0 : week1)
            );
            item.weekly2 = item.quota;
            item.weekly3 = 0;
            item.weekly4 = 0;
            item.weekly5 = 0;
            item.revisedQuota = item.weekly2;
          } else if (state.selectedDepletion.key === "depletion_80_20") {
            let w1 = week1 === undefined ? 0 : week1;
            let w2 = week2 === undefined ? 0 : week2;
            let w3 = week3 === undefined ? 0 : week3;
            let w4 = week4 === undefined ? 0 : week4;
            let w5 = week5 === undefined ? 0 : week5;

            item.weekly1 = Math.round(item.quota * w1);
            if (item.weekly1 > item.quota) {
              item.weekly1 = item.quota;
            }

            item.weekly2 = Math.round(item.quota * w2);
            if (item.weekly2 > item.quota) {
              item.weekly2 = item.quota;
            }

            item.weekly3 = Math.round(item.quota * w3);
            if (item.weekly3 > item.quota) {
              item.weekly3 = item.quota;
            }

            item.weekly4 = Math.round(item.quota * w4);
            if (item.weekly4 > item.quota) {
              item.weekly4 = item.quota;
            }

            if (item.quota * w5 !== 0) {
              item.weekly5 = item.quota;
            } else {
              item.weekly4 = item.quota;
              item.weekly5 = item.quota;
            }
            item.revisedQuota = item.quota;
          } else {
            let w1 = week1 === undefined ? 0 : week1;
            let w2 = week2 === undefined ? 0 : week2;
            let w3 = week3 === undefined ? 0 : week3;
            let w4 = week4 === undefined ? 0 : week4;
            let w5 = week5 === undefined ? 0 : week5;

            item.weekly1 = Math.round(item.quota * w1);
            if (item.weekly1 > item.quota) {
              item.weekly1 = item.quota;
            }

            item.weekly2 = Math.round(item.weekly1 + item.quota * w2);
            if (item.weekly2 > item.quota) {
              item.weekly2 = item.quota;
            }

            item.weekly3 = Math.round(item.weekly2 + item.quota * w3);
            if (item.weekly3 > item.quota) {
              item.weekly3 = item.quota;
            }

            item.weekly4 = Math.round(item.weekly3 + item.quota * w4);
            if (item.weekly4 > item.quota) {
              item.weekly4 = item.quota;
            }

            if (item.quota * w5 !== 0) {
              item.weekly5 = item.quota;
            } else {
              item.weekly4 = item.quota;
              item.weekly5 = item.quota;
            }
            item.revisedQuota = item.quota;
          }
        }
        //const updatedGrid = [];
        // for (let i = 0; i < state.gridData.length; ++i) {
        //    let itemchanged = gridDataFiltered.find(
        //       (obj) =>
        //          obj.customerID === state.gridData[i].customerID &&
        //          obj.customerGroupID ===
        //             state.gridData[i].customerGroupID &&
        //          obj.productGroupID === state.gridData[i].productGroupID &&
        //          obj.skuid === state.gridData[i].skuid
        //    );
        //    if (itemchanged) {
        //       updatedGrid.push(itemchanged);
        //    } else {
        //       updatedGrid.push(state.gridData[i]);
        //    }
        // }
        const uniqueKeys = new Map();
        for (const item of gridDataFiltered) {
          const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
          uniqueKeys.set(key, item);
        }

        const updatedGrid = [];

        for (const item of state.gridData) {
          const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
          if (uniqueKeys.has(key)) {
            updatedGrid.push(uniqueKeys.get(key));
          } else {
            updatedGrid.push(item);
          }
        }
        state.gridDataFiltered = gridDataFiltered;
        state.gridData = updatedGrid;
      }
    },
    setApplyRounder(state, { payload }) {
      state.rounder = state.rounder === null ? 0 : state.rounder;
      if (state.rounder > 0) {
        let QuotaIncreased_Decreased = 0;
        const gridDataFiltered = _.cloneDeep(state.gridDataFiltered);

        if (state.selectedDepletion.key === "None") {
          for (let i = 0; i < gridDataFiltered.length; i++) {
            let item = gridDataFiltered[i];
            if (item.weekly1 !== undefined) {
              if (typeof item.weekly1 === "string") {
                item.weekly1 = parseFloat(item.weekly1);
              }
              let modifiedValue = RoundTo(item.weekly1, state.rounder);
              QuotaIncreased_Decreased += modifiedValue - item.weekly1;
              item.weekly1 = modifiedValue;
              item.revisedQuota = modifiedValue;
              item.quota = modifiedValue; // added on 16Oct
              state.TotalQuota += item.quota;
            }
          }
        } else if (state.selectedDepletion.key === "biweekly") {
          for (let i = 0; i < gridDataFiltered.length; i++) {
            let item = gridDataFiltered[i];
            if (item.weekly1 !== undefined) {
              if (typeof item.weekly1 === "string") {
                item.weekly1 = parseFloat(item.weekly1);
              }
              let modifiedValue = RoundTo(item.weekly1, state.rounder);
              item.weekly1 = modifiedValue;
            }
            if (item.weekly2 !== undefined) {
              if (typeof item.weekly2 === "string") {
                item.weekly2 = parseFloat(item.weekly2);
              }
              let modifiedValue = RoundTo(item.weekly2, state.rounder);
              QuotaIncreased_Decreased += modifiedValue - item.weekly2;
              item.weekly2 = modifiedValue;
              item.revisedQuota = modifiedValue;
              item.quota = modifiedValue;
              state.TotalQuota += item.quota;
            }
          }
        } else {
          for (let i = 0; i < gridDataFiltered.length; i++) {
            let item = gridDataFiltered[i];
            if (item.weekly1 !== undefined) {
              if (typeof item.weekly1 === "string") {
                item.weekly1 = parseFloat(item.weekly1);
              }
              let modifiedValue = RoundTo(item.weekly1, state.rounder);
              item.weekly1 = modifiedValue;
            }
            if (item.weekly2 !== undefined) {
              if (typeof item.weekly2 === "string") {
                item.weekly2 = parseFloat(item.weekly2);
              }
              let modifiedValue = RoundTo(item.weekly2, state.rounder);
              item.weekly2 = modifiedValue;
            }
            if (item.weekly3 !== undefined) {
              if (typeof item.weekly3 === "string") {
                item.weekly3 = parseFloat(item.weekly3);
              }
              let modifiedValue = RoundTo(item.weekly3, state.rounder);
              item.weekly3 = modifiedValue;
            }
            if (item.weekly4 !== undefined) {
              if (typeof item.weekly4 === "string") {
                item.weekly4 = parseFloat(item.weekly4);
              }
              let modifiedValue = RoundTo(item.weekly4, state.rounder);
              item.weekly4 = modifiedValue;
              if (item.weekly5 === 0) item.revisedQuota = modifiedValue;
            }
            if (item.weekly5 !== undefined) {
              if (typeof item.weekly5 === "string") {
                item.weekly5 = parseFloat(item.weekly5);
              }
              let modifiedValue = RoundTo(item.weekly5, state.rounder);
              QuotaIncreased_Decreased += modifiedValue - item.weekly5;
              item.weekly5 = modifiedValue;
              item.revisedQuota = modifiedValue;
              item.quota = modifiedValue;
              state.TotalQuota += item.quota;
            }
          }
        }
        //const updatedGrid = [];
        // for (let i = 0; i < state.gridData.length; ++i) {
        //    let itemchanged = gridDataFiltered.find(
        //       (obj) =>
        //          obj.customerID === state.gridData[i].customerID &&
        //          obj.customerGroupID === state.gridData[i].customerGroupID &&
        //          obj.productGroupID === state.gridData[i].productGroupID &&
        //          obj.skuid === state.gridData[i].skuid
        //    );
        //    if (itemchanged) {
        //       updatedGrid.push(itemchanged);
        //    } else {
        //       updatedGrid.push(state.gridData[i]);
        //    }
        // }
        const uniqueKeys = new Map();
        for (const item of gridDataFiltered) {
          const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
          uniqueKeys.set(key, item);
        }

        const updatedGrid = [];

        for (const item of state.gridData) {
          const key = `${item.customerID}-${item.customerGroupID}-${item.productGroupID}-${item.skuid}`;
          if (uniqueKeys.has(key)) {
            updatedGrid.push(uniqueKeys.get(key));
          } else {
            updatedGrid.push(item);
          }
        }
        state.gridData = updatedGrid;
        state.gridDataFiltered = gridDataFiltered;
        state.comments =
          state.comments + "\r\n Rounder applied(" + state.rounder + ")";
      }
    },
    setTotalValues(state, { payload }) {
      state.TotalAdjustment = 0;
      state.TotalUnusedQuota = 0;
      state.TotalSafetyMargin = 0;
      state.TotalQuota = 0;
      for (let i = 0; i < state.gridData.length; i++) {
        if (
          state.gridData[i].adjustment !== undefined &&
          state.gridData[i].adjustment !== ""
        ) {
          state.TotalAdjustment += Math.round(
            parseFloat(state.gridData[i].adjustment)
          );
        }
        if (
          state.gridData[i].unusedQuota !== undefined &&
          state.gridData[i].unusedQuota !== ""
        ) {
          state.TotalUnusedQuota += parseFloat(state.gridData[i].unusedQuota);
        }
        let initQuota;
        let quota;
        initQuota =
          state.gridData[i].initialQuota === undefined &&
          state.gridData[i].initialQuota === ""
            ? 0
            : state.gridData[i].initialQuota;
        quota =
          state.gridData[i].quota === undefined ||
          state.gridData[i].quota === ""
            ? 0
            : state.gridData[i].quota;
        state.TotalSafetyMargin += Math.round(
          quota - initQuota - parseFloat(state.gridData[i].adjustment)
        );
        //console.log(quota-initQuota);
        state.TotalQuota += quota;
      }
    },
    setWeekPercent(state, { payload }) {
      state.TotalForecast = 0;
      for (let i = 0; i < state.gridData.length; i++) {
        if (
          state.gridData[i].initialQuota !== 0 &&
          state.gridData[i].initialQuota < state.gridData[i].minimumQuota
        )
          state.gridData[i].initialQuota = state.gridData[i].minimumQuota;

        state.TotalForecast += Math.round(state.gridData[i].initialQuota);
        if (
          state.weeklyDepletionValues !== undefined &&
          state.selectedDepletion.key !== "None"
        ) {
          state.gridData[i].weekly1Per = state.weeklyDepletionValues.week1;
          state.gridData[i].weekly2Per = state.weeklyDepletionValues.week2;
          state.gridData[i].weekly3Per = state.weeklyDepletionValues.week3;
          state.gridData[i].weekly4Per = state.weeklyDepletionValues.week4;
          state.gridData[i].weekly5Per = state.weeklyDepletionValues.week5;
        }
      }
    },
    setWeekPercentDepletion(state, { payload }) {
      state.TotalAdjustment = 0;
      state.TotalUnusedQuota = 0;
      state.TotalSafetyMargin = 0;
      state.TotalQuota = 0;
      let data = _.cloneDeep(state.gridData);
      for (let i = 0; i < data.length; i++) {
        // let share = parseFloat(data[i].sharePercentage.toString()).toFixed(
        //    5
        // );

        let sharePercentage = parseFloat(
          data[i].sharePercentage.toString()
        ).toFixed(5);
        let initQuota =
          state.selectedQuota.quotaCopy * parseFloat(sharePercentage);

        // data[i].initialQuota = Math.round(
        //    state.initialForecast * parseFloat(share)
        // );
        data[i].initialQuota = Math.round(initQuota);
        // let initialquota = state.initialForecast * parseFloat(share);
        // sharePercentage
        let initialQuotaCondition =
          initQuota !== 0 && data[i].initialQuota < data[i].minimumQuota;
        if (initialQuotaCondition) {
          data[i].initialQuota = data[i].minimumQuota;
        }

        data[i].quota = Math.round(
          data[i].initialQuota +
            ((data[i].safetyMargin * data[i].initialQuota) / 100 +
              data[i].adjustment)
        );

        state.TotalQuota += data[i].quota;
        state.TotalAdjustment += data[i].adjustment;
        state.TotalUnusedQuota += data[i].unusedQuota;
        state.TotalSafetyMargin +=
          data[i].quota - data[i].initialQuota - data[i].adjustment;

        if (
          state.weeklyDepletionValues !== undefined &&
          state.selectedDepletion.key === "None"
        ) {
          data[i].weekly1 = data[i].quota;
          data[i].weekly2 = 0;
          data[i].weekly3 = 0;
          data[i].weekly4 = 0;
          data[i].weekly5 = 0;
        } else if (
          state.weeklyDepletionValues !== undefined &&
          state.selectedDepletion.key === "biweekly"
        ) {
          data[i].weekly1 = Math.round(
            data[i].quota * state.weeklyDepletionValues.week1
          );

          if (data[i].weekly1 > data[i].quota) {
            data[i].weekly1 = data[i].quota;
          }

          data[i].weekly2 = data[i].quota;
          data[i].weekly3 = 0;
          data[i].weekly4 = 0;
          data[i].weekly5 = 0;
        } else if (
          state.weeklyDepletionValues !== undefined &&
          state.selectedDepletion.key === "depletion_80_20"
        ) {
          data[i].weekly1 = Math.round(
            data[i].quota * state.weeklyDepletionValues.week1
          );
          if (data[i].weekly1 > data[i].quota) {
            data[i].weekly1 = data[i].quota;
          }

          data[i].weekly2 = Math.round(
            data[i].quota * state.weeklyDepletionValues.week2
          );
          if (data[i].weekly2 > data[i].quota) {
            data[i].weekly2 = data[i].quota;
          }

          data[i].weekly3 = Math.round(
            data[i].quota * state.weeklyDepletionValues.week3
          );
          if (data[i].weekly3 > data[i].quota) {
            data[i].weekly3 = data[i].quota;
          }

          data[i].weekly4 = Math.round(
            data[i].quota * state.weeklyDepletionValues.week4
          );
          if (data[i].weekly4 > data[i].quota) {
            data[i].weekly4 = data[i].quota;
          }
          if (data[i].quota * state.weeklyDepletionValues.week5 !== 0) {
            data[i].weekly5 = data[i].quota;
          } else {
            data[i].weekly4 = data[i].quota;
            data[i].weekly5 = data[i].quota;
          }
        } else {
          data[i].weekly1 = Math.round(
            data[i].quota * state.weeklyDepletionValues.week1
          );
          if (data[i].weekly1 > data[i].quota) {
            data[i].weekly1 = data[i].quota;
          }

          data[i].weekly2 = Math.round(
            data[i].weekly1 + data[i].quota * state.weeklyDepletionValues.week2
          );
          if (data[i].weekly2 > data[i].quota) {
            data[i].weekly2 = data[i].quota;
          }

          data[i].weekly3 = Math.round(
            data[i].weekly2 + data[i].quota * state.weeklyDepletionValues.week3
          );
          if (data[i].weekly3 > data[i].quota) {
            data[i].weekly3 = data[i].quota;
          }

          data[i].weekly4 = Math.round(
            data[i].weekly3 + data[i].quota * state.weeklyDepletionValues.week4
          );
          if (data[i].weekly4 > data[i].quota) {
            data[i].weekly4 = data[i].quota;
          }
          if (data[i].quota * state.weeklyDepletionValues.week5 !== 0) {
            data[i].weekly5 = data[i].quota;
          } else {
            data[i].weekly4 = data[i].quota;
            data[i].weekly5 = data[i].quota;
          }
        }

        if (
          state.weeklyDepletionValues !== undefined &&
          state.selectedDepletion.key !== "None"
        ) {
          data[i].weekly1Per = state.weeklyDepletionValues.week1;
          data[i].weekly2Per = state.weeklyDepletionValues.week2;
          data[i].weekly3Per = state.weeklyDepletionValues.week3;
          data[i].weekly4Per = state.weeklyDepletionValues.week4;
          data[i].weekly5Per = state.weeklyDepletionValues.week5;
        }
      }
      state.gridData = [...data];
      state.gridDataFiltered = [...data];
      state.TotalSafetyMargin = Math.round(state.TotalSafetyMargin);
    },
    setLoadData(state, { payload }) {
      let data = state.gridData;
      let selectedRows = state.selectedRows;
      let customerIds = [];
      let customerGrpIds = [];
      let showTotalForecast = true;
      let totalQuota = 0;
      let initialQuota = 0;
      let skuPGId = state.selectedProduct.packGroupOrSKUID;
      for (let i = 0; i < selectedRows.length; ++i) {
        const rowID = selectedRows[i];
        const item = data.find((obj) => obj.id === rowID);
        if (item) {
          const obj = {
            customerid:
              item.customerID === 0 ? item.customerGroupID : item.customerID,
            custype: item.customerID === 0 ? "CG" : "C",
            skuid: item.skuid === 0 ? item.productGroupID : item.skuid,
            skutype: item.skuType,
          };
          customerGrpIds.push(obj);
          totalQuota += item.quota;
        }
        showTotalForecast = false;
        initialQuota = state.selectedQuota.quotaCopy;
      }
      if (skuPGId !== 0 && customerGrpIds.length === 0) {
        totalQuota = 0;
        initialQuota = 0;
        showTotalForecast = false;
        const item = data.filter(
          (x) => x.skuid === skuPGId || x.productGroupID === skuPGId
        );
        for (let i = 0; i < item.length; ++i) {
          totalQuota += item[i].quota;
          initialQuota += item[i].initialQuota;
        }
      }
      state.chartObj = {
        scenarioId: state.selectedScenario.scenarioID,
        startDate: state.selectedPeriod.startDate,
        endDate: state.selectedPeriod.endDate,
        isMonthly:
          state.selectedScenario.periodType === "Monthly" ? true : false,
        foreCast:
          showTotalForecast === false
            ? initialQuota
            : state.selectedQuota.quotaCopy,
        totalForeCast:
          showTotalForecast === false ? totalQuota : state.TotalQuota,
        customerIds: customerIds,
        customerGrpIds: customerGrpIds,
        skuPGId: skuPGId,
      };
    },
    setCustomerQuotaWeekValues(state, { payload }) {
      // state.isValueChanged = true;
      let safetyMargin = (payload.initialQuota * payload.safetyMargin) / 100;
      let updatedQuota = Math.round(
        payload.initialQuota + safetyMargin + payload.adjustment
      );
      const updatedRows = state.gridData.map((row) => {
        if (row.id === payload.id) {
          return {
            ...row,
            ["adjustment"]: payload.adjustment,
            ["quota"]: updatedQuota,
          };
        }
        return row;
      });
      return { ...state, gridData: updatedRows };

      // for (let i = 0; i < state.gridData.length; i++) {
      //     if (state.gridData[i].id ==== payload.id) {
      //         state.gridData[i].adjustment = payload.adjustment;
      //     }
      // }
    },
    setQuotaObject(state, { payload }) {
      const data = JSON.parse(localStorage.getItem("data"));
      state.selectedQuota.rounder = state.rounder;
      state.selectedQuota.listQuotaCustomers = state.gridData;
      state.selectedQuota.periodDepletionModel = state.selectedDepletion.key;
      state.selectedQuota.effectiveStartDate = state.selectedPeriod.startDate;
      state.selectedQuota.effectiveEndDate = state.selectedPeriod.endDate;

      state.selectedQuota.initialForecast = state.selectedQuota.quotaCopy;

      if (state.selectedScenario.periodType === "Monthly") {
        state.selectedQuota.isWeekly = false;
      } else {
        state.selectedQuota.isWeekly = true;
      }
      let startDate = dayjs(state.selectedPeriod.startDate);
      const endDate = dayjs(state.selectedPeriod.endDate);
      const currentDate = dayjs();

      if (state.selectedQuota.isWeekly) {
        if (currentDate >= startDate && currentDate <= endDate) {
          startDate = dayjs()
            .set("year", currentDate.year())
            .set("month", currentDate.month())
            .set("date", currentDate.date() + 1);
        }
      } else {
        if (currentDate.month() === startDate.month()) {
          startDate = dayjs()
            .set("year", currentDate.year())
            .set("month", currentDate.month())
            .set("date", currentDate.date() + 1);
        }
      }
      const year = startDate.year();
      const month = startDate.month() + 1;
      const date = startDate.date();
      const outputDate = `${year}-${month < 10 ? "0" + month : month}-${
        date < 10 ? "0" + date : date
      }T00:00:00`;
      state.selectedQuota.effectiveStartDate = outputDate;

      state.selectedQuota.countryId = state.selectedCountry.countryID;
      state.selectedQuota.scenarioName = state.selectedScenario.scenarioName;
      state.selectedQuota.countryName = state.selectedCountry.countryName;
      state.selectedQuota.displayDate = state.selectedPeriod.displayDate;
      if (state.selectedQuota.initialForecast === undefined) {
        state.selectedQuota.initialForecast = 0;
      }
      if (
        state.selectedQuota.comments === undefined ||
        state.selectedQuota.comments === null
      ) {
        state.selectedQuota.comments = "";
      }
      if (
        state.selectedQuota.rejectionComments === undefined ||
        state.selectedQuota.rejectionComments === null
      ) {
        state.selectedQuota.rejectionComments = "";
      }
      if (
        state.selectedQuota.approveComments === undefined ||
        state.selectedQuota.approveComments === null
      ) {
        state.selectedQuota.approveComments = "";
      }

      // if (state.selectedDepletion.key !== "None")
      //    state.selectedQuota.isWeekly = true;
      // else state.selectedQuota.isWeekly = false;

      if (payload?.method === "submitQuota") {
        state.selectedQuota.quotaStatus = "Submitted";
        if (state.selectedQuota.quotaID === 0) {
          state.selectedQuota.sentToSAP = "N";
        }
      } else if (payload?.method !== "excelDownload") {
        if (state.selectedQuota.quotaID === 0) {
          state.selectedQuota.sentToSAP = "N";
          state.selectedQuota.rejectionComments = "";
          state.selectedQuota.approveComments = "";
        }
        state.selectedQuota.quotaStatus = "Draft";
      }
      state.selectedQuota.updatedBy = data.firstName + " " + data.lastName;
      let today = new Date();
      state.selectedQuota.updatedDate = today;

      if (state.comments !== undefined && state.comments.trim() !== "") {
        if (state.comments.indexOf(state.selectedQuota.updatedBy) <= 0)
          state.selectedQuota.comments =
            state.comments +
            " " +
            state.selectedQuota.updatedBy +
            " " +
            `${new Date(today).toLocaleDateString("en-UK", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })}`;
        else state.selectedQuota.comments = state.comments;
      }
      let TotalForecast = 0;
      for (let i = 0; i < state.selectedQuota.listQuotaCustomers.length; i++) {
        if (state.selectedQuota.listQuotaCustomers[i].quota < 0) {
          state.isError = true;
          state.isError_Info =
            "Quota submitted for each Customer/Customer Group cannot be less than Zero";
          return;
        }
        TotalForecast += state.selectedQuota.listQuotaCustomers[i].quota;
      }
      state.selectedQuota.totalForecast = TotalForecast;
      state.selectedQuota.user = data;
      state.selectedQuota.rounder = state.rounder;
      let customers = prepareCustomers(state.gridData, state.gridDataFiltered);
      let result = validateCustomers(customers, state.selectedDepletion.key);

      if (typeof result === "string") {
        state.isError_Info = result;
        state.isError = true;
        state.saveOrSubmitError = 1;
      } else {
        state.selectedQuota.listQuotaCustomers2 = result;
        state.selectedQuota.files = [];
        state.selectedQuota.filePaths = state.filepath;
        if (payload?.method !== "excelDownload") {
          state.selectedQuota.listQuotaCustomers = [];
        }
      }
    },
    reset(state, { payload }) {
      if (payload === "countryChange") {
        state.selectedScenario = {};
        state.scenarioList = [];
        state.selectedPeriod = {};
        state.quotaPeriods = [];
        state.hideWeekColumns = true;
        state.weeklyDepletionList = [];
        state.selectedDepletion = {};
        state.selectedQuota = {};
        state.loadQuotaDetails = false;
        state.custBreakdownTableList = [];
        state.loadQuotaChart = false;
        state.quotaChartColumns = [];
        state.quotaChartData = [];
        state.quotaChartColors = [];
        state.quotaChartSeriesData = [];
        state.quotaChartLabelNames = [];
        state.TotalAdjustment = 0;
        state.TotalSafetyMargin = 0;
        state.TotalUnusedQuota = 0;
        state.TotalQuota = 0;
        state.TotalForecast = 0;
        state.filter_customerTypes = [];
        state.filter_customerTrustLevels = [];
        state.filter_skuName = [];
        state.filter_skuNumber = [];
        state.isWeek4Only = false;
      } else if (payload === "scenarioChange") {
        state.selectedPeriod = {};
        state.quotaPeriods = [];
        state.hideWeekColumns = true;
        state.weeklyDepletionList = [];
        state.selectedDepletion = {};
        state.selectedQuota = {};
        state.loadQuotaDetails = false;
        state.custBreakdownTableList = [];
        state.loadQuotaChart = false;
        state.quotaChartColumns = [];
        state.quotaChartData = [];
        state.quotaChartColors = [];
        state.quotaChartSeriesData = [];
        state.quotaChartLabelNames = [];
        state.TotalAdjustment = 0;
        state.TotalSafetyMargin = 0;
        state.TotalUnusedQuota = 0;
        state.TotalQuota = 0;
        state.TotalForecast = 0;
        state.filter_customerTypes = [];
        state.filter_customerTrustLevels = [];
        state.chartObj = {};
        state.listProduct = [];
        state.selectedProduct = {};
        state.selectedCustomers = [];
        state.multiplier = 0;
        state.rounder = 0;
        state.commonSafetyMargin = 0;
        state.bufferAdjustment = 0;
        state.gridData = [];
        state.gridDataFiltered = [];
        state.onSubmitDisabled = false;
        state.initialForecast = 0;
        state.forecastType = "";
        state.weeklyDepletionValues = {};
        state.onAllocateClick = false;
        state.isValueChanged = false;
        state.files = [];
        state.selectedRows = [];
        state.customerTypes = [];
        state.customerTrustLevels = [];
        state.searchText = "";
        state.selectedView = 1;
        state.filepath = [];
        state.comments = "";
        state.severity = "";
        state.filter_skuName = [];
        state.filter_skuNumber = [];
        state.isWeek4Only = false;
      } else if (payload === "onRetriveClick") {
        state.quotaChartColumns = [];
        state.quotaChartData = [];
        state.quotaChartColors = [];
        state.quotaChartSeriesData = [];
        state.quotaChartLabelNames = [];
        state.hideWeekColumns = true;
        state.onAllocateClick = false;
        state.isValueChanged = false;
        state.selectedProduct = {};
        state.filter_customerTypes = [];
        state.filter_customerTrustLevels = [];
        state.filter_skuName = [];
        state.filter_skuNumber = [];
        state.searchText = "";
        state.isWeek4Only = false;
        state.rounder = 0;
        state.commonSafetyMargin = 0;
        state.bufferAdjustment = 0;
      } else if (payload === "onAllocateClick") {
        state.quotaChartColumns = [];
        state.quotaChartData = [];
        state.quotaChartColors = [];
        state.quotaChartSeriesData = [];
        state.quotaChartLabelNames = [];
        if (state.selectedDepletion.key === "None") {
          state.hideWeekColumns = true;
        } else {
          state.hideWeekColumns = false;
        }
        state.onAllocateClick = true;
        state.selectedProduct = state.listProduct.find(
          (x) => x.packGroupOrSKUName === "All"
        );
        state.filter_customerTypes = [];
        state.filter_customerTrustLevels = [];
        state.filter_skuName = [];
        state.filter_skuNumber = [];
        state.searchText = "";
      } else if (payload === "onApplyRounder") {
        state.quotaChartColumns = [];
        state.quotaChartData = [];
        state.quotaChartColors = [];
        state.quotaChartSeriesData = [];
        state.quotaChartLabelNames = [];
        if (state.selectedDepletion.key === "None") {
          state.hideWeekColumns = true;
        } else {
          state.hideWeekColumns = false;
        }
      } else if (payload === "onProductChange") {
        state.quotaChartColumns = [];
        state.quotaChartData = [];
        state.quotaChartColors = [];
        state.quotaChartSeriesData = [];
        state.quotaChartLabelNames = [];
      } else if (payload === "onImportExcel") {
        state.quotaChartColumns = [];
        state.quotaChartData = [];
        state.quotaChartColors = [];
        state.quotaChartSeriesData = [];
        state.quotaChartLabelNames = [];
        state.filter_customerTypes = [];
        state.filter_skuName = [];
        state.filter_skuNumber = [];
        state.filter_customerTrustLevels = [];
        state.searchText = "";
      } else if (payload === "onRefresh") {
        if (state.DGlobalCountryID === "") {
          // state.countries = [];
          // state.selectedCountry = {};
        }
        state.scenarioList = [];
        state.selectedScenario = {};
        state.quotaPeriods = [];
        state.selectedPeriod = {};
        state.weeklyDepletionList = [];
        state.selectedDepletion = {};
        state.selectedQuota = {};
        state.TotalAdjustment = 0;
        state.TotalSafetyMargin = 0;
        state.TotalUnusedQuota = 0;
        state.TotalQuota = 0;
        state.TotalForecast = 0;
        state.loadQuotaDetails = false;
        state.custBreakdownTableList = [];
        state.loadQuotaChart = false;
        state.chartObj = {};
        state.quotaChartColumns = [];
        state.quotaChartData = [];
        state.quotaChartColors = [];
        state.quotaChartSeriesData = [];
        state.quotaChartLabelNames = [];
        state.hideWeekColumns = true;
        state.listProduct = [];
        state.selectedProduct = {};
        state.selectedCustomers = [];
        state.multiplier = 0;
        state.rounder = 0;
        state.commonSafetyMargin = 0;
        state.bufferAdjustment = 0;
        state.gridData = [];
        state.gridDataFiltered = [];
        state.filter_customerTypes = [];
        state.filter_customerTrustLevels = [];
        state.filter_skuName = [];
        state.filter_skuNumber = [];
        state.onSubmitDisabled = false;
        state.initialForecast = 0;
        state.forecastType = "";
        state.weeklyDepletionValues = {};
        state.onAllocateClick = false;
        state.isValueChanged = false;
        state.files = [];
        state.selectedRows = [];
        state.customerTypes = [];
        state.customerTrustLevels = [];
        state.searchText = "";
        state.selectedView = 1;
        state.filepath = [];
        state.comments = "";
        state.severity = "";
        state.messageOpen = false;
        state.isWeek4Only = false;
      } else if (payload === "onPeriodChange") {
        state.weeklyDepletionList = [];
        state.selectedDepletion = {};
        state.selectedQuota = {};
        state.TotalAdjustment = 0;
        state.TotalSafetyMargin = 0;
        state.TotalUnusedQuota = 0;
        state.TotalQuota = 0;
        state.TotalForecast = 0;
        state.loadQuotaDetails = false;
        state.custBreakdownTableList = [];
        state.loadQuotaChart = false;
        state.chartObj = {};
        state.quotaChartColumns = [];
        state.quotaChartData = [];
        state.quotaChartColors = [];
        state.quotaChartSeriesData = [];
        state.quotaChartLabelNames = [];
        state.hideWeekColumns = true;
        state.listProduct = [];
        state.selectedProduct = {};
        state.selectedCustomers = [];
        state.multiplier = 0;
        state.rounder = 0;
        state.commonSafetyMargin = 0;
        state.bufferAdjustment = 0;
        state.gridData = [];
        state.gridDataFiltered = [];
        state.filter_customerTypes = [];
        state.filter_customerTrustLevels = [];
        state.filter_skuName = [];
        state.filter_skuNumber = [];
        state.onSubmitDisabled = false;
        state.initialForecast = 0;
        state.forecastType = "";
        state.weeklyDepletionValues = {};
        state.onAllocateClick = false;
        state.isValueChanged = false;
        state.files = [];
        state.selectedRows = [];
        state.customerTypes = [];
        state.customerTrustLevels = [];
        state.searchText = "";
        state.selectedView = 1;
        state.filepath = [];
        state.comments = "";
        state.severity = "";
        state.messageOpen = false;
        state.isWeek4Only = false;
      } else if ("onNavigate") {
        state.selectedScenario = state.scenarioList[0];
        state.selectedPeriod = state.quotaPeriods[0];
      }
    },
    navigatedValues(state, { payload }) {
      state.navigatedCountryId = 0;
      state.navigatedScenarioId = 0;
    },
    addFile(state, action) {
      console.log(action.payload);
      const updatedFiles = [...state.files, action.payload];
      console.log(updatedFiles);
      state.files = updatedFiles;
    },
    deleteFile(state, action) {
      const { name, size } = action.payload;
      const updatedFiles = state.files.filter((file) => file.name !== name);
      state.files = updatedFiles;
    },
    deleteExistingFile(state, action) {
      const { filePath } = action.payload;
      const updatedFiles = state.selectedQuota?.listQuotaFiles.filter(
        (file) => file.filePath !== filePath
      );
      state.selectedQuota.listQuotaFiles = updatedFiles;
    },
    clearStatus(state, { payload }) {
      state.isSuccess = false;
      state.isSuccess_Info = false;
      state.isFailed = false;
      state.isFailed_Info = "";
      state.isError = false;
      state.isError_Info = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetUserCountries.pending, (state, action) => {})
      .addCase(GetUserCountries.fulfilled, (state, { payload }) => {
        // debugger;
        state.countries = payload;
        console.log("selectedCountry", state.selectedCountry);
        if (
          state.navigatedCountryId !== undefined &&
          state.navigatedCountryId !== null &&
          state.navigatedCountryId > 0
        ) {
          //state.countryID = state.navigatedCountryId;
          let idx = state.countries.findIndex(
            (country) => country.countryID === state.navigatedCountryId
          );
          state.selectedCountry = state.countries[idx];
        } else if (state.DGlobalCountryID !== "") {
          let idx = state.countries.findIndex(
            (country) => country.countryID === parseInt(state.DGlobalCountryID)
          );
          state.selectedCountry = state.countries[idx];
        }
        else {
          state.selectedCountry = state.countries[0];
        }
      })
      .addCase(GetUserCountries.rejected, (state, action) => {
        console.log("Error from GetUserCountries", action.error.message);
      })

      .addCase(GetScenarioforQuotaDefinition.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(
        GetScenarioforQuotaDefinition.fulfilled,
        (state, { payload }) => {
          state.isLoading = false;
          if (payload !== null && payload.length > 0) {
            state.scenarioList = payload;
            if (
              state.navigatedScenarioId !== undefined &&
              state.navigatedScenarioId > 0
            ) {
              state.selectedScenario = state.scenarioList.find(
                (scenario) => scenario.scenarioID === state.navigatedScenarioId
              );
            } else {
              state.selectedScenario = state.scenarioList[0];
            }
          } else {
            state.isFailed = true;
            state.isFailed_Info =
              "No Scenario's available for the selected country";
          }
        }
      )
      .addCase(GetScenarioforQuotaDefinition.rejected, (state, action) => {
        state.isLoading = false;
        console.log(
          "Error from GetScenarioforQuotaDefinition",
          action.error.message
        );
      })

      .addCase(GetQuotaPeriods.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(GetQuotaPeriods.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (state.selectedScenario.scenarioID) {
          if (payload !== null && payload?.length > 0) {
            state.quotaPeriods = payload;
            state.selectedPeriod = state.quotaPeriods[0];
          } else {
            state.isFailed = true;
            state.isFailed_Info =
              "No QuotaPeriods available for the selected scenario";
          }
        }
      })

      .addCase(GetQuotaPeriods.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetQuotaPeriods", action.error.message);
      })

      .addCase(GetQuotaPeriodsfromNavigation.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(
        GetQuotaPeriodsfromNavigation.fulfilled,
        (state, { payload }) => {
          state.isLoading = false;
          if (payload !== null && payload.length > 0) {
            state.quotaPeriods = payload;
            state.selectedPeriod = state.quotaPeriods[0];
          } else {
            state.isFailed = true;
            state.isFailed_Info =
              "No QuotaPeriods available for the selected scenario";
          }
        }
      )

      .addCase(GetQuotaPeriodsfromNavigation.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetQuotaPeriods", action.error.message);
      })

      .addCase(GetWeeklyDepletion.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(GetWeeklyDepletion.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload !== null && payload.length > 0) {
          state.weeklyDepletionList = payload;
          state.selectedDepletion = payload[0];
        }
      })

      .addCase(GetWeeklyDepletion.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetWeeklyDepletion", action.error.message);
      })

      .addCase(GetWeeklyDepletionValues.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(GetWeeklyDepletionValues.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload !== null) {
          state.weeklyDepletionValues = payload;
          state.hideWeekColumns = false;
          if (
            state.selectedDepletion.key !== undefined &&
            state.selectedDepletion.key !== "None" &&
            state.selectedDepletion.key !== "biweekly"
          ) {
            if (payload.week5 === 0) {
              state.isWeek4Only = true;
            } else {
              state.isWeek4Only = false;
            }
          } else {
            state.isWeek4Only = false;
          }

          const list = addWeeklyDepletionValuesToGrid(state.gridData, payload);
          state.gridData = list;
          state.gridDataFiltered = list;
        }
      })

      .addCase(GetWeeklyDepletionValues.rejected, (state, action) => {
        state.isLoading = false;
        console.log(
          "Error from GetWeeklyDepletionValues",
          action.error.message
        );
      })

      .addCase(GetSKUOrPGByScenario.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(GetSKUOrPGByScenario.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload !== null && payload.length > 0) {
          state.listProduct = payload.sort(
            (a, b) => a.packGroupOrSKUID - b.packGroupOrSKUID
          );
          state.selectedProduct = payload.find(
            (x) => x.packGroupOrSKUName === "All"
          );
        }
      })

      .addCase(GetSKUOrPGByScenario.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetSKUOrPGByScenario", action.error.message);
      })

      .addCase(GetQuotaDetails.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetQuotaDetails.fulfilled, (state, { payload }) => {
        // debugger;
        state.isLoading = false;
        if (payload !== null) {
          const data = JSON.parse(localStorage.getItem("data"));
          if (payload.listQuotaCustomers.length <= 0) {
            state.onSubmitDisabled = true;
          } else if (data.isAdmin === true) {
            state.onSubmitDisabled = false;
          } else {
            if (
              payload.quotaStatus === "Submitted" ||
              payload.quotaStatus === "Approved" ||
              payload.quotaStatus === "Draft" ||
              payload.quotaStatus === "Rejected" ||
              payload.quotaStatus === "Locally Approved"
            ) {
              state.onSubmitDisabled = payload.isSubmitLocked;
            }
          }
          if (!state.onAllocateClick) {
            const weeklyDepletionList = _.cloneDeep(state.weeklyDepletionList);
            console.log("weeklyDepletionList", weeklyDepletionList);

            let wObj = weeklyDepletionList.find(
              (p) => p.key === payload.previousPeriodDepletionModel
            );
            if (wObj === undefined) {
              wObj = weeklyDepletionList.find((p) => p.key === "None");
            }
            state.selectedDepletion = wObj;

            if (state.selectedScenario.periodType === "Weekly") {
              let wObj = weeklyDepletionList.find((p) => p.key === "None");
              if (wObj !== undefined) state.selectedDepletion = wObj;
            }

            console.log("wObj", wObj);

            state.initialForecast = Math.round(payload.initialForecast);
            state.quotaCopy = Math.round(payload.quotaCopy);
            state.forecastType = payload.forecastType;
            state.rounder = payload?.rounder;
            state.selectedQuota = payload;
            const table = prepareGridData(
              payload?.listQuotaCustomers,
              payload?.initialForecast
            );
            state.comments = payload?.comments.split("<br/>").join("\n");
            state.revisedQuota = payload?.revisedQuota;
            state.gridData = table;
            state.gridDataFiltered = table.slice();
            state.customerTypes = getAllCustomerTypes(state.gridDataFiltered);
            state.customerTrustLevels = getAllCustomerTrustLevels(
              state.gridDataFiltered
            );
            state.SKUList = getAllSKUList(state.gridDataFiltered);
            const skuNumbers = state.SKUList.map((item) => item.skuNumber);
            state.skuNumberList = [...new Set(skuNumbers)];
            const skuNames = state.SKUList.map((item) => item.skuName);
            state.skuNameList = [...new Set(skuNames)];
          } else {
            state.custBreakdownTableList = payload?.listQuotaCustomers;
            // on allocate click following lines was not getting executed
            const table = prepareGridData(
              payload?.listQuotaCustomers,
              payload?.initialForecast
            );
            state.comments = payload?.comments.split("<br/>").join("\n");
            state.revisedQuota = payload?.revisedQuota;
            state.gridData = table;
            state.gridDataFiltered = table.slice();
            state.customerTypes = getAllCustomerTypes(state.gridDataFiltered);
            state.customerTrustLevels = getAllCustomerTrustLevels(
              state.gridDataFiltered
            );
            state.SKUList = getAllSKUList(state.gridDataFiltered);
          }
          state.loadQuotaDetails = true;
        }
      })
      .addCase(GetQuotaDetails.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetQuotaDetails", action.error.message);
      })

      .addCase(GetQuotaChartData.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(GetQuotaChartData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload !== null) {
          console.log("GetQuotaChartData", payload);
          state.quotaChartColumns = payload.columns;
          state.quotaChartData = payload.data;
          state.quotaChartColors = payload.colors;
          let data = [];
          for (let i = 0; i < state.quotaChartData.length; i++) {
            let s = state.quotaChartData[i][0].split(",");
            for (let k = 0; k < s.length; k++) {
              if (k > 0) {
                if (!isNaN(s[k])) s[k] = Number(s[k]);
                if (s[k] === "null") {
                  s[k] = null;
                } else if (i < state.quotaChartData.length - 1 && s[k] === 0) {
                  s[k] = null;
                }
              }
            }
            data.push(s);
          }
          let labelNames = [];
          data.forEach((item) => {
            labelNames.push(item[0]);
          });
          state.quotaChartLabelNames = labelNames;

          let seriesDatas = [];
          for (let i = 1; i < state.quotaChartColumns.length; i++) {
            let seriesData = [];
            data.forEach((item) => {
              seriesData.push(item[i]);
            });

            seriesDatas.push({
              name: state.quotaChartColumns[i],
              data: seriesData,
            });
          }
          state.quotaChartSeriesData = seriesDatas;
          const quotaTableData = getQuotaTableData(
            payload.columns,
            payload.data
          );
          state.quotaTableData = quotaTableData;
          state.loadQuotaChart = true;
        }
      })

      .addCase(GetQuotaChartData.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetQuotaChartData", action.error.message);
      })

      .addCase(ExportExcel.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(ExportExcel.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload !== null) {
          saveAs(
            payload,
            state.selectedCountry.countryName +
              "_" +
              state.selectedScenario.scenarioName +
              "_Import.xlsx"
          );
        } else {
          state.isFailed = true;
          state.isFailed_Info =
            "Export of Quota file failed. Please try after some time!";
        }
      })
      .addCase(ExportExcel.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from ExportExcel", action.error.message);
      })

      .addCase(ImportExcel.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ImportExcel.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload !== null) {
          let customers = [];
          customers = payload?.listQuotaCustomers;
          if (customers === undefined) {
            state.isFailed = true;
            state.isFailed_Info =
              "Error occured while importing file. Please try again with correct file.";
            return;
          }
          if (customers === undefined || customers.length === 0) {
            state.isFailed = true;
            state.isFailed_Info = "No record to import for file";
            return;
          }
          for (let i = 0; i < customers.length; i++) {
            if (
              customers[i].customerNumber === undefined ||
              customers[i].customerNumber === "0" ||
              customers[i].customerNumber === null
            ) {
              if (
                customers[i].skuNumb === undefined ||
                customers[i].skuNumb === "0" ||
                customers[i].skuNumb === null
              ) {
                let item = state.gridData.find(
                  (p) =>
                    p.customerGroupName === customers[i].customerName &&
                    p.skuName === customers[i].skuName
                );
                if (item !== undefined) {
                  item.initialQuota = customers[i].initialQuota;
                  if (
                    item.initialQuota !== 0 &&
                    item.initialQuota < item.minimumQuota
                  ) {
                    item.initialQuota = item.minimumQuota;
                  }

                  item.adjustment = customers[i].adjustment;
                  item.customerQuotaComments =
                    customers[i].customerQuotaComments;
                  item.safetyMargin = customers[i].safetyMargin;
                  // this.SetCustomerQuotaWeekValues(item);
                  let safetyMargin =
                    (item.initialQuota * item.safetyMargin) / 100;
                  let updatedQuota = Math.round(
                    item.initialQuota + safetyMargin + item.adjustment
                  );
                  if (state.selectedDepletion.key === "None") {
                    item.weekly1 = updatedQuota;
                  } else if (state.selectedDepletion.key === "biweekly") {
                    item.weekly1 = Math.round(customers[i].weekly1);
                    item.weekly2 = updatedQuota;
                  } else {
                    item.weekly1 = Math.round(customers[i].weekly1);
                    item.weekly2 = Math.round(customers[i].weekly2);
                    item.weekly3 = Math.round(customers[i].weekly3);
                    if (state.isWeek4Only === true) {
                      item.weekly4 = updatedQuota;
                    } else {
                      item.weekly4 = Math.round(customers[i].weekly4);
                    }
                    item.weekly5 = updatedQuota;
                  }
                  const updatedRows = state.gridData.map((row) => {
                    if (row.id === item.id) {
                      return {
                        ...row,
                        ["adjustment"]: item.adjustment,
                        ["quota"]: updatedQuota,
                      };
                    }
                    return row;
                  });
                  //return { ...state, gridData: updatedRows };
                  state.gridData = updatedRows;
                }
              } else {
                let item = state.gridData.find(
                  (p) =>
                    p.customerGroupName === customers[i].customerName &&
                    p.skuNumb === customers[i].skuNumb
                );
                if (item !== undefined) {
                  item.initialQuota = customers[i].initialQuota;
                  if (
                    item.initialQuota !== 0 &&
                    item.initialQuota < item.minimumQuota
                  ) {
                    item.initialQuota = item.minimumQuota;
                  }

                  item.adjustment = customers[i].adjustment;
                  item.customerQuotaComments =
                    customers[i].customerQuotaComments;
                  item.safetyMargin = customers[i].safetyMargin;
                  // this.SetCustomerQuotaWeekValues(item);
                  let safetyMargin =
                    (item.initialQuota * item.safetyMargin) / 100;
                  let updatedQuota = Math.round(
                    item.initialQuota + safetyMargin + item.adjustment
                  );
                  if (state.selectedDepletion.key === "None") {
                    item.weekly1 = updatedQuota;
                  } else if (state.selectedDepletion.key === "biweekly") {
                    item.weekly1 = Math.round(customers[i].weekly1);
                    item.weekly2 = updatedQuota;
                  } else {
                    item.weekly1 = Math.round(customers[i].weekly1);
                    item.weekly2 = Math.round(customers[i].weekly2);
                    item.weekly3 = Math.round(customers[i].weekly3);
                    if (state.isWeek4Only === true) {
                      item.weekly4 = updatedQuota;
                    } else {
                      item.weekly4 = Math.round(customers[i].weekly4);
                    }
                    item.weekly5 = updatedQuota;
                  }
                  const updatedRows = state.gridData.map((row) => {
                    if (row.id === item.id) {
                      return {
                        ...row,
                        ["adjustment"]: item.adjustment,
                        ["quota"]: updatedQuota,
                      };
                    }
                    return row;
                  });
                  //return { ...state, gridData: updatedRows };
                  state.gridData = updatedRows;
                }
              }
            } else {
              if (
                customers[i].skuNumb === undefined ||
                customers[i].skuNumb === "0" ||
                customers[i].skuNumb === null
              ) {
                let item = state.gridData.find(
                  (p) =>
                    p.customerNumber === customers[i].customerNumber &&
                    p.skuName === customers[i].skuName
                );
                if (item !== undefined) {
                  item.initialQuota = customers[i].initialQuota;
                  if (
                    item.initialQuota !== 0 &&
                    item.initialQuota < item.minimumQuota
                  ) {
                    item.initialQuota = item.minimumQuota;
                  }
                  item.adjustment = customers[i].adjustment;
                  item.customerQuotaComments =
                    customers[i].customerQuotaComments;
                  item.safetyMargin = customers[i].safetyMargin;
                  // this.SetCustomerQuotaWeekValues(item);
                  let safetyMargin =
                    (item.initialQuota * item.safetyMargin) / 100;
                  let updatedQuota = Math.round(
                    item.initialQuota + safetyMargin + item.adjustment
                  );
                  if (state.selectedDepletion.key === "None") {
                    item.weekly1 = updatedQuota;
                  } else if (state.selectedDepletion.key === "biweekly") {
                    item.weekly1 = Math.round(customers[i].weekly1);
                    item.weekly2 = updatedQuota;
                  } else {
                    item.weekly1 = Math.round(customers[i].weekly1);
                    item.weekly2 = Math.round(customers[i].weekly2);
                    item.weekly3 = Math.round(customers[i].weekly3);
                    if (state.isWeek4Only === true) {
                      item.weekly4 = updatedQuota;
                    } else {
                      item.weekly4 = Math.round(customers[i].weekly4);
                    }
                    item.weekly5 = updatedQuota;
                  }
                  const updatedRows = state.gridData.map((row) => {
                    if (row.id === item.id) {
                      return {
                        ...row,
                        ["adjustment"]: item.adjustment,
                        ["quota"]: updatedQuota,
                      };
                    }
                    return row;
                  });
                  //return { ...state, gridData: updatedRows };
                  state.gridData = updatedRows;
                }
              } else {
                let item = state.gridData.find(
                  (p) =>
                    p.customerNumber === customers[i].customerNumber &&
                    p.skuNumb === customers[i].skuNumb
                );

                if (item !== undefined) {
                  item.initialQuota = customers[i].initialQuota;
                  if (
                    item.initialQuota !== 0 &&
                    item.initialQuota < item.minimumQuota
                  ) {
                    item.initialQuota = item.minimumQuota;
                  }
                  item.adjustment = customers[i].adjustment;
                  item.customerQuotaComments =
                    customers[i].customerQuotaComments;
                  item.safetyMargin = customers[i].safetyMargin;
                  // this.SetCustomerQuotaWeekValues(item);
                  let safetyMargin =
                    (item.initialQuota * item.safetyMargin) / 100;
                  let updatedQuota = Math.round(
                    item.initialQuota + safetyMargin + item.adjustment
                  );
                  if (state.selectedDepletion.key === "None") {
                    item.weekly1 = updatedQuota;
                  } else if (state.selectedDepletion.key === "biweekly") {
                    item.weekly1 = Math.round(customers[i].weekly1);
                    item.weekly2 = updatedQuota;
                  } else {
                    item.weekly1 = Math.round(customers[i].weekly1);
                    item.weekly2 = Math.round(customers[i].weekly2);
                    item.weekly3 = Math.round(customers[i].weekly3);
                    if (state.isWeek4Only === true) {
                      item.weekly4 = updatedQuota;
                    } else {
                      item.weekly4 = Math.round(customers[i].weekly4);
                    }
                    item.weekly5 = updatedQuota;
                  }
                  const updatedRows = state.gridData.map((row) => {
                    if (row.id === item.id) {
                      return {
                        ...row,
                        ["adjustment"]: item.adjustment,
                        ["quota"]: updatedQuota,
                      };
                    }
                    return row;
                  });
                  //return { ...state, gridData: updatedRows };
                  state.gridData = updatedRows;
                }
              }
            }
          }
          state.gridDataFiltered = state.gridData;
          let customersList = prepareCustomers(
            state.gridData,
            state.gridDataFiltered
          );
          let validationResult = validateCustomers(
            customersList,
            state.selectedDepletion.key
          );
          if (typeof validationResult === "string") {
            state.isError_Info = validationResult;
            state.isError = true;
          } else {
            state.isSuccess = true;
            state.isSuccess_Info = "Customer data imported successfully.";
          }
        } else {
          state.isFailed = true;
          state.isFailed_Info =
            "No Scenario's available for the selected country";
        }
      })
      .addCase(ImportExcel.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from ImportExcel", action.error.message);
      })

      .addCase(SaveQuota.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(SaveQuota.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (typeof payload !== "string") {
          state.isSuccess = true;
          state.isSuccess_Info = "Quota saved successfully";
          state.selectedQuota = payload;
        } else if (typeof payload === "string") {
          state.isFailed_Info = payload;
          state.isFailed = true;
        } else {
          state.isFailed_Info = "Error occured in save quota";
          state.isFailed = true;
        }
        state.gridDataChanged = false;
      })
      .addCase(SaveQuota.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isError_Info = "Error occured in save quota";
        console.log("Error from SaveQuota", action.error.message);
      })

      .addCase(SubmitQuota.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(SubmitQuota.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (typeof payload === "number") {
          state.isSuccess = true;
          state.isSuccess_Info = "Quota submitted successfully";
        } else if (typeof payload === "string") {
          state.isFailed_Info = payload;
          state.isFailed = true;
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in submit quota";
        }
        state.gridDataChanged = false;
      })
      .addCase(SubmitQuota.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isError_Info = "Error occured in submit quota";
        console.log("Error from SubmitQuota", action.error.message);
      })

      .addCase(Upload.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(Upload.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.filepath = payload.map((x) => x.filePath);
        state.files = [];
      })
      .addCase(Upload.rejected, (state, action) => {
        state.isLoading = false;
      })

      .addCase(exportFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(exportFile.fulfilled, (state, { payload }) => {
        state.isLoading = false;
      })
      .addCase(exportFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from exportFile", action.error.message);
      });
  },
});

export const {
  // setCountries,
  setState,
  setSelectedCountry,
  setSelectedScenario,
  setSelectedPeriod,
  setForecast,
  setQuotaCopy,
  setTimeDepletion,
  setSelectProduct,
  setRounder,
  setSafetyMargin,
  setBufferAdjustment,
  setApplyRounder,
  SetCustomerQuotaValues,
  setApplySafetyMargin,
  setApplyBufferAdjustment,
  setTotalValues,
  setWeekPercent,
  setWeekPercentDepletion,
  setLoadData,
  clearStatus,
  setCustomerQuotaWeekValues,
  setQuotaObject,
  reset,
  navigatedValues,
  addFile,
  deleteFile,
  deleteExistingFile,
} = defineSlice.actions;

export default defineSlice.reducer;
